<app-form-select [formControl]="formControl"
                 [data]="regions$ | async"
                 [templateType]="'tree'"
                 [label]="'Region'"></app-form-select>

